import React from 'react';

import pinImage from 'src/assets/pin.png';
import unPinImage from 'src/assets/unpin.png';

import { ToolboxCollapsiblePropsType } from './toolbox-collapsible.config';
import Collapse from 'antd/es/collapse';

const { Panel } = Collapse;

const ToolboxCollapsible: React.FC<ToolboxCollapsiblePropsType> = ({
  id,
  children,
  className,
  headerText,
  expandIconPosition,
  panelClassName,
  onClickPin,
  displayPin,
  forceDisplayClose,
  pinStatus,
  onClickClose,
  onCollapseChange,
  collapsed,
}) => {
  const onClickPinImage = (event: React.MouseEvent<HTMLImageElement>) => {
    event.stopPropagation();

    if (onClickPin) {
      onClickPin();
    }
  };

  const onClickImage = (event: React.MouseEvent<HTMLImageElement>) => {
    event.stopPropagation();

    if (onClickClose) {
      onClickClose();
    }
  };

  const buttons = (_pinStatus: boolean | undefined) => {
    return (
      <>
        {displayPin && (
          <img style={{ width: '20px' }} src={_pinStatus ? pinImage : unPinImage} alt="" onClick={onClickPinImage} />
        )}

        {(forceDisplayClose || (_pinStatus && onClickClose)) && (
          <img style={{ width: '20px' }} src="/assets/closePopupIcon.png" alt="close" onClick={onClickImage} />
        )}
      </>
    );
  };

  const onChange = (_key: string | string[]) => {
    if (onCollapseChange) {
      onCollapseChange();
    }
  };

  return (
    <Collapse
      key={id}
      expandIconPosition={expandIconPosition || 'left'}
      className={className || 'bar-collapse'}
      defaultActiveKey={collapsed ? undefined : '1'}
      onChange={onChange}
    >
      <Panel
        header={
          !pinStatus ? (
            <div className="bar-header-text">
              <span>{headerText}</span>
            </div>
          ) : (
            <span style={{ color: 'white' }}>{headerText}</span>
          )
        }
        className={`sticky-bar-header ${pinStatus ? 'sticky-bar-header-pinned' : ''}`}
        key="1"
        extra={buttons(pinStatus)}
        showArrow={!pinStatus}
        collapsible={!pinStatus ? 'header' : 'disabled'}
        id={id}
      >
        {children}
      </Panel>
    </Collapse>
  );
};

ToolboxCollapsible.defaultProps = {
  displayPin: true,
};

export default ToolboxCollapsible;
